export class ImageSignature {
  idUsuario!: string;
  imagen!: string;
  firma!: string;
  pdf!: string;

  constructor(image: ImageSignature) {
    {
      this.idUsuario = image.idUsuario || '';
      this.imagen = image.imagen || '';
      this.firma = image.firma || '';
      this.pdf = image.pdf || '';
    }
  }
}
